<template>
    <modal id="role-modal"
           v-model="showModal"
           :title="['employee-del', 'department_manager-del'].includes(formData.alias) ? this.$t('permissions') : (this.manage ? $fieldTitle('manage', 'permissions', true) : generateModalTitle('role'))"
           @submit="submitData"
           :loading="loading"
           :hide-submit-button="['employee-del', 'department_manager-del'].includes(formData.alias)"
           :cancel-btn-label="['employee-del', 'department_manager-del'].includes(formData.alias) ? this.$t('close') : this.$t('cancel')"
           :hide-footer="(formData.is_admin && formData.is_default)"
           :preloader="preloader">

        <div v-if="formData.id !== 1 && !(formData.is_default && formData.is_admin)">
            <form ref="form"
                  :class="{'disabled-section' : ['employee-del', 'department_manager-del'].includes(formData.alias)}"
                  :data-url='selectedUrl ? `${getSubmitURL}/${this.formData.id}` : getSubmitURL'
                  @submit.prevent="submitData">
                <template v-if="!manage">
                    <app-form-group
                        v-model="formData.name"
                        :label="$t('name')"
                        :placeholder="$placeholder('name')"
                        :error-message="$errorMessage(errors, 'name')"
                    />
                </template>
                <div class="form-group" v-if="Object.keys(data.permissions).length">
                    <app-message type="error" :message="$errorMessage(errors, 'permissions')"/>

                    <div class="permission-table">
                        <div class="permission-table-header d-flex border-bottom">
                            <div class="module-name flex-grow-1">
                                <div class="customized-checkbox checkbox-default d-flex">
                                    <input type="checkbox"
                                           id="all-modules-checkbox"
                                           v-model="allModulesChecked"
                                           @change="checkAllModules"/>
                                    <label class="fw-bold" for="all-modules-checkbox">
                                        <b>{{ $t('module') }}</b>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="permission-table-body">
                            <div class="permission-row d-flex flex-column border-bottom" v-for="(permission, index) in permissionsExceptAccessDepartment" :key="index">
                                <div class="module-name flex-grow-1">
                                    <div class="customized-checkbox checkbox-default">
                                        <input type="checkbox"
                                               :name="`single-checkbox-${permission}`"
                                               :id="`single-checkbox-${permission}`"
                                               :value="permission"
                                               :checked="ifChecked(permission)"
                                               @input="checkGroup($event, permission)"
                                               ref="checkbox"
                                               v-if="loadChecked"/>
                                        <label class="mb-0" :for="`single-checkbox-${permission}`">
                                            <b>{{ $t(permission) }}</b>
                                        </label>
                                    </div>
                                </div>
                                <div class="permissions-list">
                                    <app-input type="checkbox"
                                               v-if="loaded"
                                               :list="data.permissions[permission]"
                                               v-model="checkedPermissions[permission]"
                                               @input="checkPermissions(permission)"
                                               :show-tooltip="true"
                                               list-value-field="translated_name"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-else>
                    <app-pre-loader/>
                </div>
            </form>
        </div>
        <div v-else>
            {{ $t('action_not_allowed') }}
        </div>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../Mixin/Global/ModalMixin";
import {APP_ROLES, TENANT_ROLES} from "../../../Config/apiUrl";

export default {
    name: "AppRolesModal",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        data: {
            default: function () {
                return {
                    permissions: {},
                    types: []
                }
            }
        },
        manage: {},
        alias: {}
    },
    data() {
        return {
            permissions: [],
            checkedPermissions: {},
            brands: [],
            loaded: true,
            loadChecked: true,
            allModulesChecked: false,
        }
    },
    mounted() {
        this.setFormData();
        this.updateAllModulesCheckbox();
    },
    created() {
      this.permissionsExceptAccessDepartment.map(permission => this.checkedPermissions[permission] = []);
    },
    methods: {
        checkAllModules(event) {
            if (event.target.checked) {
                this.permissionsExceptAccessDepartment.forEach(permission => {
                    const permissions = this.collection(this.data.permissions[permission]).pluck('id');
                    this.$set(this.checkedPermissions, permission, permissions);
                    this.checkPermissions(permission);
                });
            } else {
                this.permissionsExceptAccessDepartment.forEach(permission => {
                    this.$set(this.checkedPermissions, permission, []);
                    const permissions = this.collection(this.data.permissions[permission]).pluck('id');
                    this.permissions = this.permissions.filter(p => !permissions.includes(parseInt(p)));
                });
            }
        },
        
        updateAllModulesCheckbox() {
            this.allModulesChecked = this.permissionsExceptAccessDepartment.every(permission => {
                const allPermissionIds = this.collection(this.data.permissions[permission]).pluck('id');
                const checkedPermissionIds = this.checkedPermissions[permission] || [];
                return allPermissionIds.length === checkedPermissionIds.length;
            });
        },
        submitData() {
            this.formData.is_manager == true ? this.formData.is_manager = 1 : this.formData.is_manager = 0;
            const role = {
                ...this.formData,
                permissions: this.permissions.map(permission => {
                    return {
                        permission_id: permission
                    }
                })
            }
            this.loading = true;
            this.save(role);
        },
        afterSuccess({data}) {
            this.toastAndReload(data.message, 'role-table');
            this.$hub.$emit('rolesAffected')
            this.loading = false;
            this.closeModal()
        },
        afterSuccessFromGetEditData(response) {
            this.formData = response.data;
            this.formData.is_manager = response.data.permissions.find(permission => permission.name === 'access_all_departments') ? 1 :0;
            this.preloader = false;
            this.permissions = this.collection(response.data.permissions).pluck('id');
            Object.keys(this.data.permissions).map(permission => {
                let checked = this.data.permissions[permission].filter(p => {
                    return this.permissions.includes(p.id);
                })
                this.checkedPermissions[permission] = this.collection(checked).pluck('id');
            })
        },
        closeModal() {
            $('#role-modal').modal('hide');
        },
        checkGroup(event, permission) {
            this.loaded = false;
            const permissions = this.collection(this.data.permissions[permission]).pluck('id');
            if (event.target.checked) {
                this.$set(this.checkedPermissions, permission, permissions);
                this.checkPermissions(permission);
            } else {
                this.$set(this.checkedPermissions, permission, []);
                this.permissions = this.permissions.filter(p => !permissions.includes(parseInt(p)));
            }
            this.loaded = true;
            this.updateAllModulesCheckbox();
        },
        checkForVisibility(index, permission) {
            return (this.checkedPermissions[permission] && this.checkedPermissions[permission].length)
        },
        checkPermissions(permission) {
            this.loadChecked = false;
            const all_permission_of_group = this.collection(this.data.permissions[permission]).pluck('id');
            const checked_permissions = this.checkedPermissions[permission].map(p => parseInt(p));
            const removable_permissions = all_permission_of_group.filter(permission => !checked_permissions.includes(permission));
            this.permissions = this.permissions.filter(permission => !removable_permissions.includes(parseInt(permission)));
            this.permissions = Array.from(new Set(this.permissions.concat(checked_permissions)));
            this.loadChecked = true;
            
            this.updateAllModulesCheckbox();
            this.$nextTick(() => {
            });
        },
        ifChecked(permission) {
            const permissions = this.collection(this.data.permissions[permission]).pluck();
            const checked = this.checkedPermissions[permission];
            return permissions.length === checked.length;
        },
        setFormData() {
            const type = this.data.types.find(type => type.alias === this.alias);
            this.formData.type_id = type.id;
            this.formData.tenant_id = null;
            if (this.alias === 'tenant') {
                this.formData.tenant_id = window.tenant.id
            }
        }
    },
    computed: {
        getSubmitURL() {
            return {
                tenant: TENANT_ROLES,
                app: APP_ROLES,
            }[this.alias];
        },
      permissionsExceptAccessDepartment(){
        return Object.keys(this.data.permissions).filter(name => name !== 'access_department')
      }
    }
}
</script>

<style lang="scss" scoped>
    @media (min-width: 768px) {
        ::v-deep .modal-default {
            max-width: 70% !important;
        }
    }
    ::v-deep .permission-table {
        .module-name {

        }
        .app-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            column-gap: 2rem;
        }
        .customized-checkbox input + label:before {
            margin-right: 0.25rem;
        }
        .customized-checkbox {
            label {
                overflow: hidden;
                text-overflow: ellipsis;
                text-wrap: nowrap;
                width: 100%;
            }
        }
        .permission-table-header {
            padding: 0.75rem 1.25rem;
            font-weight: 700;
            .permissions-list {
                width: 80%;
            }
        }
        .permission-row {
            padding: 0.75rem 1.25rem;
            &:last-child {
                border-bottom: none !important;
            }
            .permissions-list {
                margin-top: 1rem;
                width: 100%;

                .app-checkbox-group {
                    display: flex;
                    flex-wrap: wrap;
                }
                .customized-checkbox {
                    width: calc((100% - 6rem) / 4);
                }
            }
        }
    }
</style>
